// src/Components/Header/HeaderData.jsx
import React from "react";

// ====== BRAND STYLE DEFINITIONS ======
const brandBlue = "#22429a";
const softBlue = "#6c8cd5";

const mainLinkStyle = {
  color: brandBlue,
  WebkitTextFillColor: brandBlue,
  fontSize: "15px",
  fontWeight: 400,
  letterSpacing: "0.3px",
  lineHeight: "1.8",
  display: "block",
};

const subLinkStyle = {
  color: brandBlue,
  WebkitTextFillColor: brandBlue,
  fontSize: "14px",
  fontWeight: 400,
  letterSpacing: "0.2px",
  lineHeight: "1.8",
  paddingLeft: "18px", // indentation
  position: "relative",
  display: "block",
};

// prepend subtle hyphen before submenu items
const createSubTitle = (text) => (
  <span style={subLinkStyle}>
    <span style={{ position: "absolute", left: "0px" }}>–</span> {text}
  </span>
);

// default title generator for main items
const createTitle = (text) => <span style={mainLinkStyle}>{text}</span>;

// ====== NAVIGATION STRUCTURE ======
const HeaderData = [
  {
    title: createTitle("Home"),
    link: "/",
  },
  {
    title: createTitle("Solutions"),
    dropdown: [
      { title: createSubTitle("Bean-to-Cup"), link: "/solutions/bean-to-cup" },
      { title: createSubTitle("Instant Beverage Machines"), link: "/solutions/instant-machines" },
      { title: createSubTitle("Snacks & Beverage Machines"), link: "/solutions/SnackBeverageVending" },
      { title: createSubTitle("Beverage Essentials"), link: "/solutions/BeverageEssentials" },

    //   { title: createSubTitle("Smart Tray"), link: "/solutions/smart-tray" },
    //   { title: createSubTitle("Refill Subscriptions"), link: "/solutions/refill-subscriptions" },
    
  ],
  },
  {
    title: createTitle("Articles"),
    link: "/articles",
  },
  {
    title: createTitle("Contact"),
    link: "/contact",
  },
  {
    title: createTitle("More"),
    dropdown: [
      { title: createSubTitle("Careers"), link: "/careers" },
      { title: createSubTitle("Privacy Policy"), link: "/privacy" },
      { title: createSubTitle("Terms of Use"), link: "/terms" },
    ],
  },
];

export default HeaderData;
